import { useEffect, useState } from 'react';
import { isAfter, parseISO } from 'date-fns';
import { useQuery } from '@apollo/client';
import { VIEWER_EVENTS_QUERY } from '@general/graphql/viewer.graph';

const useViewerEvents = ({ futureOnly, ...options } = {}) => {
    const [events, setEvents] = useState();
    const { data, ...rest } = useQuery(VIEWER_EVENTS_QUERY, options);

    useEffect(() => {
        if (!data) {
            return;
        }

        let viewerEvents = data.viewer.events.filter(event => !!event);
        if (futureOnly) {
            viewerEvents = viewerEvents.filter(event => isAfter(parseISO(event.beginsAt), new Date()));
        }

        setEvents(viewerEvents);
    }, [data, futureOnly]);

    return { data: events, ...rest };
};

export default useViewerEvents;
